import {bootstrapApplication} from '@angular/platform-browser';
import {routes} from "./app/app.routes";
import {provideRouter, withRouterConfig} from "@angular/router";
import {provideZonelessChangeDetection} from "@angular/core";
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {provideTranslateService} from "@ngx-translate/core";

import localeNl from '@angular/common/locales/nl';
import {registerLocaleData} from "@angular/common";
import {AppComponent} from "./app/components/app.component";
import {environment} from "./environments/environment";
import {AngLiebCoreHttpService} from "@liebink/ang-lieb-core";
import {errorInterceptor} from "./app/interceptor/error.interceptor";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";

registerLocaleData(localeNl, 'nl_NL');

bootstrapApplication(
    AppComponent,
    {
        providers: [
            {
                provide: 'env',
                useValue: environment,
            },

            provideZonelessChangeDetection(),
            provideRouter(
                routes,
                withRouterConfig({
                    paramsInheritanceStrategy: 'always',
                }),
            ),
            provideHttpClient(
                withInterceptors([errorInterceptor]),
            ),

            provideTranslateService(
                {
                    loader: provideTranslateHttpLoader(
                        {
                            prefix: './assets/i18n/',
                            suffix: '.json',
                        },
                    ),
                    fallbackLang: 'nl_NL',
                }
            ),

            AngLiebCoreHttpService,
        ],
    }
)
    .catch((err) => console.error(err));
